<template>
  <Container type="card-full" v-loading="loading">
    <!--<div slot="header">-->
    <!--</div>-->
    <div class="view-container" v-if="psu">
      <div class="view-box">
        <div class="view-row">
          <div class="view-field">
            <div class="view-label">项目编号</div>
            <div class="view-value">{{ psu.projectcode }}</div>
          </div>
          <div class="view-field">
            <div class="view-label">平台编号</div>
            <div class="view-value">{{ psu.projectno }}</div>
          </div>
          <div class="view-field">
            <div class="view-label">采购人</div>
            <div class="view-value">{{ psu.pcomfullname }}</div>
          </div>
        </div>
        <div class="view-row">
          <div class="view-field">
            <div class="view-label">项目名称</div>
            <div class="view-content">{{ psu.projectname }}</div>
          </div>
        </div>
        <div class="view-row">
          <div class="view-field">
            <div class="view-label">报名方式</div>
            <div class="view-value">
              {{ +psu.projectisinvite === 1 ? "邀请" : "公开" }}
            </div>
          </div>
        </div>
        <!--<div class="view-row">-->
        <!--<div class="view-field">-->
        <!--<div class="view-label">报价开始</div>-->
        <!--<div class="view-value">{{psu.prsbjbegtime | newDate}}</div>-->
        <!--</div>-->
        <!--</div>-->
        <div class="split-line" v-if="+psu.psubidflg === 1"></div>
        <div class="view-row" v-if="+psu.psubidflg === 1">
          <div class="view-field">
            <div class="view-label">电子合同</div>
            <div style="color: #2f74ff; cursor: pointer" @click="downFile(append.appendurl)" v-if="Appendcount > 0">
              <a :src="$store.getters.uploadAddr + append.appendurl">{{
                  append.appendfilename
              }}</a>
            </div>
            <div v-else class="view-value">
              无

              <span style="
                  margin-left: 30px;
                  color: blue;
                  font-size: 13px;
                  cursor: pointer;
                " @click="showdzhtbox" v-if="
                  Number($store.getters.loginUser.userid) ===
                  Number(psu.projectcuserid)
                ">[点击上传]</span>
            </div>
          </div>
        </div>
        <div class="split-line"></div>
        <div class="view-row">
          <div class="view-field">
            <div class="view-label">报名单位</div>
            <div class="view-value">{{ psu.comfullname }}</div>
          </div>
          <div class="view-field">
            <div class="view-label">经办人</div>
            <div class="view-value">
              {{ psu.psuusername }} {{ psu.psuusertel }}
            </div>
          </div>
          <div class="view-field">
            <div class="view-label">报名时间</div>
            <div class="view-value">{{ psu.psutime | newDate }}</div>
          </div>
        </div>
        <div class="view-row">
          <div class="view-field">
            <div class="view-label">报名联系人</div>
            <div class="view-value">{{ psu.psucontactname }}</div>
          </div>
          <div class="view-field">
            <div class="view-label">报名电话</div>
            <div class="view-value">{{ psu.psucontactphone }}</div>
          </div>
          <div class="view-field">
            <div class="view-label">联系邮箱</div>
            <div class="view-value">{{ psu.psucontactmail }}</div>
          </div>
        </div>
        <div class="view-row">
          <div class="view-field">
            <div class="view-label">单位名称</div>
            <div class="view-value">{{ psu.comfullname }}</div>
          </div>
          <div class="view-field">
            <div class="view-label">信用代码</div>
            <div class="view-value">{{ psu.comidcode }}</div>
          </div>
          <div class="view-field">
            <div class="view-label">单位电话</div>
            <div class="view-value">{{ psu.comtel }}</div>
          </div>
        </div>
        <div class="view-row">
          <div class="view-field">
            <div class="view-label">单位地址</div>
            <div class="view-value">
              {{ psu.comaddr }}
            </div>
          </div>
          <div class="view-field">
            <div class="view-label">开户银行</div>
            <div class="view-value">
              {{ psu.combank }}
            </div>
          </div>
          <div class="view-field">
            <div class="view-label">开户账号</div>
            <div class="view-value">
              {{ psu.combanknumber }}
            </div>
          </div>
        </div>
        <div class="view-row" v-if="psu.psufwfinvoice">
          <div class="view-field">
            <div class="view-label">发票类型</div>
            <div class="view-value">
              {{
                  +psu.psufwfinvoice === 1
                    ? "增值税普通"
                    : +psu.psufwfinvoice === 2
                      ? "增值税专用"
                      : ""
              }}
            </div>
          </div>
          <div class="view-field" v-if="psu.psuInvoicmark">
            <div class="view-label">开票申请备注</div>
            <div class="view-con">
              {{ psu.psuInvoicmark }}
            </div>
          </div>
        </div>
        <div class="view-row">
          <div class="view-field" style="align-items: center;">
            <div class="view-label">状态</div>
            <div class="view-value" style="width: 400px;">
              <div v-if="isEdit && +psu.psutype === 1">
                <el-radio v-for="(item, index) in psustatusList" :key="index" v-model="psu.psustatus"
                  @change="changestatus" :label="item.value">{{ item.label }}
                </el-radio>
              </div>
              <div v-else>
                {{ statusName }}
              </div>
              <el-button type="primary" icon="el-icon-message"  @click="auditLogListVisible = true" size="small" v-if="+psu.prsbmneedconfirm === 1 && +psu.projectisinvite !== 1" style="margin-left: 28px;">审核日志</el-button>
            </div>
          </div>
          <div class="view-field" v-if="psu.psubmcheckusername">
            <div class="view-label">审核人</div>
            <div class="view-value">
              {{ psu.psubmcheckusername }}
            </div>
          </div>
          <div class="view-field" v-if="psu.psubmchecktime">
            <div class="view-label">审核时间</div>
            <div class="view-value">
              {{ psu.psubmchecktime | newDate }}
            </div>
          </div>
        </div>
        <div v-if="+psu.psutype === 1">
          <div class="view-row" v-if="+psu.psustatus === 2 || +psu.psustatus === 4">
            <div class="view-field">
              <div class="view-label" v-if="+psu.psustatus === 2">
                <span>*</span>驳回意见
              </div>
              <div class="view-label" v-if="+psu.psustatus === 4">
                <span>*</span>拒绝意见
              </div>
              <div class="view-con">
                <div v-if="isEdit">
                  <el-input type="textarea" :autosize="{ minRows: 6 }" width="300" v-model="psu.psubmcheckdesc"
                    :maxlength="255" show-word-limit></el-input>
                  </div>
                
                <div v-else style="color: red; font-weight: bold">
                  <div v-html="psu.psubmcheckdesc.replace(/\n/g, '<br>').replace(/ /g, '&nbsp;')"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="view-row" v-if="isEdit">
            <div class="view-field">
              <div class="view-label"></div>
              <div class="view-value">
                <el-button type="primary" @click="save" :loading="btnLoading">保存</el-button>
              </div>
            </div>
          </div>
        </div>
        <div class="split-line"></div>
        <div class="view-row">
          <div class="view-field">
            <div class="view-label">报名费</div>
            <div class="view-value">
              <div v-if="+psu.psubmpayflg === 1">
                <div v-if="+psu.psubmpaytype === 3">
                  <div>
                    {{ psu.projectbmamt }}元<span style="color: red" v-if="psu.projectbmamt > 0">（已支付）</span>
                  </div>
                </div>
                <div v-else>
                  <div>
                    {{ psu.projectbmamt }}元
                    <span style="color: red">（已支付）</span>
                  </div>
                  <div>
                    支付方式:{{
                        psu.psubmpaytype == 1 ? "支付宝支付" : "微信支付"
                    }}
                  </div>
                  <div>交易号:{{ psu.psubmpaytradeno }}</div>
                </div>
              </div>
              <div v-else>
                {{ psu.projectbmamt }}元
                <span style="color: red" v-if="+psu.projectbmamt === 0">（免费）</span>
                <span style="color: red" v-else>（未支付）<span @click="ruseBMFee" class="ruseBMFee">【点击催费】</span></span>
              </div>
            </div>
          </div>
        </div>
        <div class="view-row" v-if="psu.psubmpayurl">
          <div class="view-field">
            <div class="view-label">支付凭证</div>
            <div class="view-value">
              <popover-img v-if="psu.psubmpayurl" :img-src="psu.psubmpayurl ? uploadAddr + psu.psubmpayurl : ''"
                default-height="150" after-height="400"></popover-img>
            </div>
          </div>
        </div>
        <div class="split-line"></div>
        <div class="view-row">
          <div class="view-field">
            <div class="view-label">保证金</div>
            <div class="view-value">
              <div v-if="+psu.psubzjpayflg === 1">
                <div v-if="+psu.psubzjpaytype === 3">
                  <div>
                    {{ psu.projectbzjamt }}元<span style="color: red" v-if="psu.projectbzjamt >= 0">（已支付）</span>
                  </div>
                </div>
                <div v-else>
                  <div>
                    {{ psu.projectbzjamt }}元
                    <span style="color: red">（已支付）</span>
                  </div>
                  <div>
                    支付方式:{{
                        psu.psubzjpaytype == 1 ? "支付宝支付" : "微信支付"
                    }}
                  </div>
                  <div>交易号:{{ psu.psubzjpayno }}</div>
                </div>
              </div>
              <div v-else>
                {{ psu.projectbzjamt }}元
                <span style="color: red" v-if="+psu.projectbzjamt === 0">（免费）</span>
                <span style="color: red" v-else>（未支付）<span @click="ruseBzjFee" class="ruseBzjFee">【点击催费】</span></span>
              </div>
            </div>
          </div>
        </div>
        <div class="view-row" v-if="psu.psubzjpayurl">
          <div class="view-field">
            <div class="view-label">支付凭证</div>
            <div class="view-value">
              <popover-img v-if="psu.psubzjpayurl" :img-src="psu.psubzjpayurl ? uploadAddr + psu.psubzjpayurl : ''"
                default-height="150" after-height="400"></popover-img>
            </div>
          </div>
        </div>
        <div class="split-line" v-if="+psu.psubidflg === 1"></div>
        <div class="view-row" v-if="+psu.psubidflg === 1 && $store.getters.loginUser.comtype == '1'">
          <div class="view-field">
            <div class="view-label">服务费</div>
            <div class="view-value">
              <div v-if="+psu.psufewreceive === 1">
                <div v-if="+psu.psufeepaytype === 3">
                  <div>
                    {{ psu.psuconfirmfeeamt }}元<span style="color: red" v-if="psu.psuconfirmfeeamt >= 0">（已支付）</span>
                  </div>
                </div>
                <div v-else>
                  <div>
                    {{ psu.psuconfirmfeeamt }}元
                    <span style="color: red">（已支付）</span>
                  </div>
                  <div>
                    支付方式:{{
                        psu.psufeepaytype == 1 ? "支付宝支付" : "微信支付"
                    }}
                  </div>
                  <div>交易号:{{ psu.psufeepayno }}</div>
                </div>
              </div>
              <div v-else>
                {{ psu.psuconfirmfeeamt }}元
                <span style="color: red" v-if="+psu.psuconfirmfeeamt === 0">（免费）</span>
                <span style="color: red" v-else>（未支付）</span>
              </div>
            </div>
          </div>
        </div>
        <div class="view-row"
          v-if="psu.psufeepayurl && psu.psuconfirmfeeamt && $store.getters.loginUser.comtype == '1'">
          <div class="view-field">
            <div class="view-label">支付凭证</div>
            <div class="view-value">
              <popover-img v-if="psu.psufeepayurl" :img-src="psu.psufeepayurl ? uploadAddr + psu.psufeepayurl : ''"
                default-height="150" after-height="400"></popover-img>
            </div>
          </div>
        </div>
        <div class="split-line" v-if="$store.getters.loginUser.comtype == '1'"></div>
        <div class="view-row">
          <div class="view-field">
            <div class="view-label">报名文件</div>
            <div class="view-value" style="width: 450px">
              <div v-if="!showFile" class="view-filelist">
                <div v-for="(item, index) in appendList" :key="index" class="view-fileitem">
                  <div class="view-filename" @click="downFile(item.appendurl, item.appendid)">
                    <a :src="uploadAddr + item.appendurl">{{
                        item.appendfilename
                    }}</a>
                  </div>
                  <span style="color:#606266;margin-left: 12px">上传时间：<span style="color:999">{{item.appendfiletime | newDate}}</span></span>
                </div>
              </div>
              <div v-else>
                <div>
                  <upload-btn @changed="setfilebmfj" text="上传报名文件"></upload-btn>
                </div>
                <div v-if="appendBmList.length">
                  <div class="view-filelist">
                    <div v-for="(item, index) in appendBmList" :key="index" class="view-fileitem">
                      <div class="view-filename" @click="downFile(item.appendurl, item.appendid)">
                        <a :src="uploadAddr + item.appendurl">{{
                            item.appendfilename
                        }}</a>
                      </div>
                      <!---->
                      <div class="view-filebtn" @click="delappend(item)">
                        <span>删除</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="appendBmList.length">
                  <vxe-button type="primary" @click="savebmfj">保存</vxe-button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="split-box" v-if="psu.projectbmamt > 0">
          <div class="split-line"></div>
          <div class="split-name">【报名费发票】</div>
        </div>
        <div class="view-row" v-if="psu.projectbmamt > 0">
          <div class="view-field">
            <div class="view-label">开票</div>
            <div class="view-value">
              {{ +psu.psubminvoiceflg === 2 ? "已开" : "未开" }}
            </div>
          </div>
          <div class="view-field" v-if="+psu.psubminvoiceflg === 2">
            <div class="view-label">发票号</div>
            <div class="view-value">{{ psu.psubminvoicenum }}</div>
          </div>
          <div class="view-field" v-if="+psu.psubminvoiceflg === 2">
            <div class="view-label">开票时间</div>
            <div class="view-value">{{ psu.psubminvoicetime | newDate }}</div>
          </div>
        </div>
        <div class="split-box" v-if="psu.psuconfirmfeeamt > 0">
          <div class="split-line"></div>
          <div class="split-name">【服务费发票】</div>
        </div>
        <div class="view-row" v-if="psu.psuconfirmfeeamt > 0">
          <div class="view-field">
            <div class="view-label">开票</div>
            <div class="view-value">
              {{ +psu.psufwfinvoiceflg === 2 ? "已开" : "未开" }}
            </div>
          </div>
          <div class="view-field" v-if="+psu.psufwfinvoiceflg === 2">
            <div class="view-label">发票号</div>
            <div class="view-value">{{ psu.psufwfinvoicenum }}</div>
          </div>
          <div class="view-field" v-if="+psu.psufwfinvoiceflg === 2">
            <div class="view-label">开票时间</div>
            <div class="view-value">{{ psu.psufwfinvoicetime | newDate }}</div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="上传电子合同" :visible.sync="dzhtflg" width="50%">
      <div>
        <upload-btn @changed="setfileAppend" text="上传电子合同"></upload-btn>
      </div>
      <div v-if="append_ht">
        <div style="color: #2f74ff; cursor: pointer; padding-left: 20px" @click="downFile(append_ht.appendurl)"
          v-if="append_ht.appendfilename">
          <a :src="$store.getters.uploadAddr + append_ht.appendurl">{{
              append_ht.appendfilename
          }}</a>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="seveAppend" :loading="btnLoading" v-if="append_ht.appendfilename">保存
        </el-button>
      </span>
    </el-dialog>
    <el-dialog title="审核日志" @open="auditDialogOpen" :loading="auditDialogLoading" :visible.sync="auditLogListVisible" width="50%">
      <audit-log-list :auditLogList="auditLogList"></audit-log-list>
    </el-dialog>
  </Container>
</template>

<script>
import request from "@/utils/request";
import utils from "../../assets/js/utils";
import popoverImg from "../common/popoverImg";
import uploadPicOne from "../common/uploadPicOne";
import uploadBtn from "../common/uploadBtn";
import common from "@/mixin/common";
import dayjs from "dayjs";
import _ from "lodash";
import AuditLogList from "./auditLogList.vue";

export default {
  name: "psuBmForm",
  mixins: [common],
  props: {
    ctype: Number,
  },
  data() {
    return {
      auditDialogLoading: false,
      auditLogListVisible: false,
      auditLogList: [],
      psu: {},
      psuStatus: "",
      dzhtflg: false,
      type: this.ctype || Number(this.$route.params.type),
      btnLoading: false,
      psuisopenList: [],
      psustatusList: [],
      appendList: [],
      appendBmList: [],
      loading: false,
      btnLoading: false,
      Appendcount: 0,
      append: [],
      append_ht: {},
      psuCloneStatus: 1,
      auditlogfromid: null
    };
  },
  // created() {
  //   this.getModel();
  //   this.getPsustatusList();
  // },
  activated() {
    this.getModel();
    this.getPsustatusList();
  },
  watch: {},
  filters: {
    newDate(value) {
      return value ? dayjs(value).format("YYYY-MM-DD HH:mm:ss") : "";
    },
    qfwVal(value) {
      return utils.comdify(value);
    },

    keepSecret(num) {
      var mobile = String(num);
      var reg = /^(\d{3})\d{4}(\d{4})$/;
      return mobile.replace(reg, "$1****$2");
    },
  },
  components: { uploadPicOne, popoverImg, uploadBtn, AuditLogList },
  computed: {
    isEdit () {
      if (+this.psu.prsbmneedconfirm === 1 && +this.psuCloneStatus === 1 && this.appendList.length === 0 && dayjs(this.psu.prsbmendtime).isBefore(dayjs())) { 
        return false
      }
      else if (+this.psuCloneStatus === 1) {
        return true;
      } else {
        return false;
      }
    },
    statusName () {
      if (+this.psu.prsbmneedconfirm === 1 && +this.psuCloneStatus === 1 && +this.appendList.length === 0 && dayjs(this.psu.prsbmendtime).isBefore(dayjs())) {
          return '无效'
      } else {
        if (+this.psuCloneStatus === 1) {
          return '待审'
        } else if (+this.psuCloneStatus === 2) {
          return '驳回'
        } else if (+this.psuCloneStatus === 3) {
          return '通过'
        } else if (+this.psuCloneStatus === 4) {
          return '拒绝'
        }
      }
    },
    uploadAddr() {
      return this.$store.getters.uploadAddr;
    },
    statusname() {
      let model = this.psustatusList.find(
        (v) => +this.psu.psustatus === +v.value
      );
      if (model) {
        return model.label;
      }
    },
    showFile() {
      // if (+this.psuStatus === 3) return true
      // else return false   0833P21D000984
      if (this.appendList && this.appendList.length) {
        return false
      } else {
        if (+this.$store.getters.loginUser.comtype === 1 && +this.psuStatus !== 3) return false
        else return true
      }

    }
  },
  methods: {
    async getAuditLogList() {
      this.auditDialogLoading = true
      return request({
        url: '/auditlog/getAuditLog',
        method: 'get',
        params: {
          auditlogfromid: this.psu.psuid,
          auditlogcosid: this.$store.getters.loginUser.cosid,
          auditlogcode: 10
        }
      })
    },
    async auditDialogOpen () {
      this.auditDialogLoading = false
      const data = await this.getAuditLogList()
      this.auditLogList = data
    },
    async setfileAppend(path, filename) {
      this.append_ht = {
        appendid: 0,
        appendfromid: this.$route.params.psuid,
        appendfromtype: 21,
        appendtype: "100",
        appendseq: 1,
        appendfilecode: "",
        appendfilename: filename,
        appendurl: path.replace(this.uploadAddr, ""),
      };
    },
    async seveAppend() {
      this.$confirm(`请确保上传的单位合同准确无误，上传后将不能修改`, "提示", {
        confirmButtonText: "是",
        cancelButtonText: "否",
        type: "warning",
      })
        .then(async () => {
          let res = await request({
            url: "ywgl/append/addOnlyOne",
            method: "post",
            data: this.append_ht,
          });
          if (+res.issuccess === 1) {
            this.getModel();
            this.dzhtflg = false;
            this.$message.success("保存成功");
          }
        })
        .catch(() => { });
    },
    async getModel() {
      this.loading = true;
      this.btnLoading = true;
      this.appendBmList = [];
      let res = await request({
        method: "get",
        url: "/xmgl/project/getpsubyid",
        params: { psuid: this.$route.params.psuid },
      });
      this.psu = res[0];
      this.psu.projectbzjamt = utils.comdify(this.psu.projectbzjamt);
      this.psu.projectbmamt = utils.comdify(this.psu.projectbmamt);
      // await this.getIsEdit();
      await this.getAppends();
      await this.getAppend();
      this.psuCloneStatus = +this.psu.psustatus
      if (+this.psu.psustatus === 1) {
        this.psu.psustatus = "";
      }
      this.psuStatus = _.cloneDeep(this.psu.psustatus)
      this.btnLoading = false;
      this.loading = false;
    },
    btnClick(code) {
      this.$emit(code);
    },
    async getPsustatusList() {
      this.psustatusList = await request({
        url: "/kfgl/syscode/getSysCodeList",
        method: "get",
        params: { syscode: "psustatus" },
      });
      if (+this.$store.getters.loginUser.comtype !== 3) {
        this.psustatusList.splice(0, 1);
      }
    },
    async getAppends() {
      this.appendList = await request({
        method: "get",
        url: "/ywgl/append/getAppendListByFromId",
        params: { appendfromid: this.$route.params.psuid, appendfromtype: 10 },
      });
    },
    async getAppend() {
      let res = await request({
        method: "get",
        url: "ywgl/append/getAppendListByFromId",
        params: { appendfromid: this.$route.params.psuid, appendfromtype: 21 },
      });
      this.Appendcount = res.length;
      this.append = res[0];
    },
    async setfilebmfj(path, filename) {
      let append = {
        appendid: 0,
        appendfromid: this.$route.params.psuid,
        appendfromtype: 10,
        appendtype: 100,
        appendseq: this.appendBmList.length + 1,
        appendfilecode: "",
        appendfilename: filename,
        appendurl: path.replace(this.uploadAddr, ""),
      };
      this.appendBmList.push(append);
    },
    async savebmfj() {
      let data = await request({
        url: "/xmgl/project/reuploadbyProjectclerk",
        method: "post",
        data: {
          psuid: this.$route.params.psuid,
          appends: this.appendBmList,
          psustatus: 1,
        },
      });
      if (data.issuccess === 1) {
        this.$message.success("附件上传成功");
        this.getModel();
      } else {
        this.$message.error("附件上传失败");
      }
    },
    delappend(file) {
      this.$confirm(`确定移除 ${file.appendfilename}？`, "提示", {
        type: "warning",
      })
        .then(() => {
          let index = this.appendBmList.findIndex(
            (val) => val.appendfilename === file.appendfilename
          );
          this.appendBmList.splice(index, 1);
        })
        .catch(() => { });
    },
    async save() {
      if (!this.psu.psustatus) {
        this.$message.warning("请选择状态!");
        return;
      }
      if (+this.psu.psustatus === 3 && this.appendList.length <= 0 && +this.psu.prsbmneedconfirm === 1) {
        this.$message.warning('该项目报名要求审批，没上传报名文件，不能审批')
        return
      }
      if (
        (+this.psu.psustatus === 2 || +this.psu.psustatus === 4) &&
        !this.psu.psubmcheckdesc
      ) {
        this.$message.warning(
          `请输入${+this.psu.psustatus === 2 ? "驳回意见" : "拒绝意见"}!`
        );
        return;
      }
      let model = {
        projectid: this.psu.projectid,
        cosid: this.$store.getters.loginUser.cosid,
        psuid: this.psu.psuid,
        psustatus: this.psu.psustatus,
        psubzjpayurl: this.psu.psubzjpayurl,
        psubmpayurl: this.psu.psubmpayurl,
        psubmcheckdesc: this.psu.psubmcheckdesc,
        psuuserid: this.psu.psuuserid,
        userid: this.$store.getters.loginUser.userid,
      };
      let data = await request({
        url: "/xmgl/project/savePsuConfirm",
        method: "post",
        data: model,
      });
      if (data.issuccess === 1) {
        this.$message.success("报名审核成功");
        this.psuConfirm(model);
        this.sms();
        // this.close();
        this.$router.push({
          name: "BMXXlist",
          params: { projectid: this.psu.projectid, type: 1 },
        });
      } else {
        this.$message.error("报名审核失败!" + data.msg);
      }
    },
    async psuConfirm(model) {
      model.psucontactphone = this.psu.psucontactphone
      await request({
        url: "/xmgl/project/psuConfirmNotice",
        method: "post",
        data: model,
      });
    },
    close() {
      this.$store.commit("close_tab", {
        routeName: this.$route.name,
        vm: this,
        newRouteName: "psuCheckIndex",
      });
    },
    async sms() {
      await request({
        url: "/sms/send",
        method: "get",
        params: {
          type: "2",
          tel: this.psu.psuusertel,
          status: this.psu.psustatus,
        },
      });
    },
    changestatus() {
      this.psu.psubmcheckdesc = "";
    },
    // 是否可编辑
    async ruseBzjFee() {
      let form = {};
      form.projectid = this.psu.projectid;
      form.psuid = this.psu.psuid;
      form.cosid = this.$store.getters.loginUser.cosid;

      this.$confirm("是否催款", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let data = await request({
            url: "/info/rush/rushbzjfee",
            method: "get",
            params: form,
          });
          this.$message.success("催费成功");
        })
        .catch(() => { });
    },
    async ruseBMFee() {
      this.$confirm("是否催款", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let form = {};
          form.projectid = this.psu.projectid;
          form.psuid = this.psu.psuid;
          form.cosid = this.$store.getters.loginUser.cosid;

          let data = await request({
            url: "/info/rush/rushbmfee",
            method: "get",
            params: form,
          });
          this.$message.success("催费成功");
        })
        .catch(() => { });
    },
    async showdzhtbox() {
      this.dzhtflg = true;
    },
  },
};
</script>


<style lang="scss" scoped>
@import "../../styles/filelist";

.main {
  .amt {
    display: flex;
    flex-direction: column;
  }

  .link {
    padding-left: 10px;
    color: #2f74ff;
    cursor: Pointer;
  }

  .from_input .el-input,
  .el-input .el-input__inner,
  .el-select {
    width: 200px;
  }

  .content .el-textarea__inner,
  .el-textarea,
  .el-input {
    width: 200px;
  }

  .file {
    display: flex;
    flex-direction: column;
    width: 70%;
  }
}

.ruseFee {
  cursor: pointer;
  color: red;
}
</style>
